import type { SubstrateSearchSuggestionsResponse } from "../../data/schema/SubstrateSearchSuggestionsResponse";

export default function filterRoomPeopleSuggestions(response: SubstrateSearchSuggestionsResponse, shouldFilterRoomResults: boolean): void {
    if (!shouldFilterRoomResults) {
        return;
    }
    
    for (const group of response.Groups ?? []) {
        if (group.Type === "People") {
            group.Suggestions = group.Suggestions.filter(suggestion => suggestion.PeopleSubtype !== "Room");
        }
    }
}
